import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GridOptions, ColumnApi } from "ag-grid/main";
import { NotificationsService } from 'angular2-notifications';
import { AgGridUtility, ServerConstantsService, APP_DATE_FORMAT, DOUBLE_ROW_HEADER, DataService, Task } from '../shared';
import { TaskDetails } from '../shared/model/task-details.model';

@Component({
  selector: 'app-task-details',
  templateUrl: './employment-plan-audit.component.html',
  styleUrls: ['./employment-plan-audit.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class EmploymentPlanAuditComponent implements OnInit {
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER
  completedBy: string;
  employementPlanId: number;
  serverConstants: any;
  href: string = "";
  userId: any;
  task: TaskDetails;
  tasks: TaskDetails[] = [];
  context: any;
  columnDefs: any;
  sharedData: any;
  component: string;
  entityId: string;
  entityType: string;
  entityPageTitle: string;
  pageId: String;
  entityColumnDefs: any;
  smaple: any;
  gridOptions: GridOptions;
  gridApi: any;
  isUniverse = false;
  // Define/Declare Floating constant here...
  // auditElements: { label: any, value: any }[] = [];
  constructor(
    private serverConstantsService: ServerConstantsService,
    private http: HttpClient,
    private notificationService: NotificationsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private agGridUtility: AgGridUtility,
    private dataService: DataService,
  ) {
    this.gridOptions = <GridOptions>{};
    this.serverConstants = this.serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('EMPPL') == undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.task = new TaskDetails();
    this.sharedData = this.dataService.getSharedDataObject();
    this.entityId = this.sharedData.get('auditEnitiyId');
    this.entityType = this.sharedData.get('auditEnitiyType');
    this.entityPageTitle = this.sharedData.get('auditPageTitle');
    this.pageId = this.sharedData.get('pageId');
    this.context = this.sharedData.get('component');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    
    let url = '';
    switch (this.pageId) {
      case 'RIMBS':
        url = this.serverConstants.REIM_SERVER_API_URL_AUDIT;
        this.dataService.removeValueFromSharedDataMap('pageId');
        break;
      case 'NCMPL':
        url = this.serverConstants.NC_SERVER_API_URL_AUDIT;
        this.dataService.removeValueFromSharedDataMap('pageId');
        break;
      default:
        url = this.serverConstants.SERVER_API_URL;
        this.dataService.removeValueFromSharedDataMap('pageId');
    }

    // Get the Floating Data from data service..
    // this.auditElements = this.sharedData.get('floatingData');
    this.getColumnDefinitions();
    this.http.get<any[]>(url + '/audits/entity/changes/id', {
      params: {
        entityType: this.entityType,
        entityId: this.entityId,
        limit: '5'
      }
    }).subscribe(
      (val) => {
        let entities: Array<any> = [];
        let requestUserNames: Array<any> = [];
        val.forEach(x => {
          let data = JSON.parse(x.entityValue);
          if (x.action === 'CREATE') {
            entities.push(data);
          } else {
            data['createdBy'] = x.modifiedBy;
            data['createdDt'] = x.modifiedDate;
            entities.push(data);
          }
          requestUserNames.push(data['createdBy']);
        });

        this.http.post<any>(this.serverConstants.SERVER_API_URL + '/user/usernames', requestUserNames).subscribe((data) => {
          let keys = Object.keys(data);
          for (let i = 0; i < keys.length; i++) {
            for (let j = 0; j < entities.length; j++) {
              if (entities[j].createdBy === keys[i]) {
                entities[j].createdBy = data[keys[i]];
              }
            }
          }
          this.tasks = entities;
          this.employementPlanId = +this.entityId;
        })
      },
      response => {
        this.notificationService.error('Task Search');
      }
    );
  }

  focusHeader(event) {
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes 
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards     
    } else {
      // prevents tabbing into the url section when navigating forward  
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var rowNode = this.gridApi.getDisplayedRowAtIndex(0);

    // scrolls to the first row 
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column 
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell 
    this.gridApi.setFocusedCell(0, firstCol);
  }



  getColumnDefinitions() {
    return this.entityColumnDefs = this.sharedData.get('auditEnitiyColumnDefs');
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getCompletedByName() {
    let Index = this.tasks.findIndex(o => o.empPlanStatusCd === 'SC');
    if (Index !== -1) {
      return this.tasks[Index].createdBy;
    } else {
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/employment-plan-audit/employment-plan-audit.component.ts